import useProxy from '../Hooks/useProxy';

export default function API() {
  const proxy = useProxy();

  return {
    getCurrentVersion: (onSuccess, onFailure) =>
      // eslint-disable-next-line no-undef
      proxy.run(`Version/${APP_NAME}`, 'get', null, onSuccess, onFailure, {
        silent: true,
      }),
    getWaveSections: (onSuccess, onFailure) =>
      proxy.run('Customers/WaveSections', 'get', null, onSuccess, onFailure),
    /**GENERAL**/
    getAllBranches: (onSuccess, onFailure) =>
      proxy.run('Branches', 'get', null, onSuccess, onFailure, {
        silent: true,
      }),
    /****/
    /**User APIs**/
    getUserVoIPDevices: (UserId, onSuccess, onFailure) =>
      proxy.run(
        `Users/GetUserVoIPDevices/${encodeURIComponent(UserId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),

    setUserVoIPDevices: (UserId, VoipDevice, onSuccess, onFailure) =>
      proxy.run(
        `Users/SetUserVoIPDevices/${encodeURIComponent(UserId)}/${encodeURIComponent(VoipDevice)}`,
        'post',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),

    getLoggedUserBranches: (onSuccess, onFailure) =>
      proxy.run('Branches/currentUser', 'get', null, onSuccess, onFailure),
    changePassword: (ChangePwdData, onSuccess, onFailure) =>
      proxy.run(
        `Auth/changePassword`,
        'post',
        ChangePwdData,
        onSuccess,
        onFailure
      ),
    /******/

    /**Get Contacts APIs**/
    getCustomers: (
      BranchId,
      { type, period, sectionName, wavePeriod },
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Customers/${encodeURIComponent(type)}/${
          period ? `${encodeURIComponent(period)}/` : ''
        }${encodeURIComponent(BranchId)}${wavePeriod ? `/${wavePeriod}` : ''}${
          sectionName ? `?SectionName=${encodeURIComponent(sectionName)}` : ''
        }`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),

    export2Excel: (
      BranchId,
      { type, period, sectionName, wavePeriod },
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Customers/${encodeURIComponent(type)}/Export2Excel/${
          period ? `${encodeURIComponent(period)}/` : ''
        }${encodeURIComponent(BranchId)}${wavePeriod ? `/${wavePeriod}` : ''}${
          sectionName ? `?SectionName=${encodeURIComponent(sectionName)}` : ''
        }`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),

    /******/

    /**Activities APIs **/
    getActivity: (ActivityId, onSuccess, onFailure) =>
      proxy.run(
        `Activities/${encodeURIComponent(ActivityId)}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    getActivityHistory: (EntityId, params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/History/${encodeURIComponent(EntityId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),

    getPurchaseHistory: (params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/SMSPurchases/History`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),

    /******/

    /**Call APIs**/
    startCall: (
      EntityId,
      BranchId,
      PhoneNumber,
      CustomerDataObj,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Activities/Call/start/${encodeURIComponent(
          EntityId
        )}/${encodeURIComponent(PhoneNumber)}/${encodeURIComponent(BranchId)}`,
        'post',
        CustomerDataObj,
        onSuccess,
        onFailure
      ),
    startRecall: (EntityId, PhoneNumber, ActivityId, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Recall/start/${EntityId}/${PhoneNumber}/${ActivityId}`,
        'post',
        null,
        onSuccess,
        onFailure
      ),
    endCall: (CallId, callInfosObject, withTemplates, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Call/end/${encodeURIComponent(CallId)}/${encodeURIComponent(withTemplates)}`,
        'put',
        {
          ...callInfosObject,
          callOutcome: {
            ...(callInfosObject?.callOutcome ?? {}),
            nextActivityData: callInfosObject?.callOutcome?.nextActivityData
              ? JSON.stringify(callInfosObject.callOutcome.nextActivityData)
              : null,
          },
        },
        onSuccess,
        onFailure
      ),
    dropCall: (CallId, params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Call/drop/${encodeURIComponent(CallId)}`,
        'put',
        null,
        onSuccess,
        onFailure,
        params
      ),
    registerCall: (
      EntityId,
      BranchId,
      PhoneNumber,
      callInfosObj,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Activities/Call/register/${encodeURIComponent(
          EntityId
        )}/${encodeURIComponent(BranchId)}/${encodeURIComponent(PhoneNumber)}`,
        'put',
        callInfosObj,
        onSuccess,
        onFailure
      ),
    todayCalls: (BranchId, params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Call/history/today/${encodeURIComponent(BranchId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    answerCall: (CustomerId, BranchId, onSuccess, onFailure) =>
      proxy.run(
        `Customers/callanswered/${encodeURIComponent(CustomerId)}/${encodeURIComponent(BranchId)}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    /******/

    /**Mail APIs**/
    sendEmail: (EmailObject, params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Email/send`,
        'post',
        EmailObject,
        onSuccess,
        onFailure,
        params
      ),
    getEmailHistory: (EntityId, params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Email/history/${encodeURIComponent(EntityId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getAppointmentHistory: (EntityId, params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Appointment/history/${encodeURIComponent(EntityId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    downloadFile: (AttachmentId, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Email/Attachment/${encodeURIComponent(AttachmentId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    /****/

    /**Customers APIs**/
    getCustomer: (customerId, BranchId, onSuccess, onFailure) =>
      proxy.run(
        `Customers/${encodeURIComponent(customerId)}/${encodeURIComponent(BranchId)}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    getCallsHistory: (EntityId, params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Call/history/${encodeURIComponent(EntityId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getEntityMessages: (entityId, unreadOnly, params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/SMS/history/${encodeURIComponent(
          entityId
        )}/${encodeURIComponent(unreadOnly)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params,
        { silent: true }
      ),
    changePhoneNumberStatus: (ContactId, PhoneNumber, onSuccess, onFailure) =>
      proxy.run(
        `Customers/${encodeURIComponent(
          ContactId
        )}/PhoneNumber/${encodeURIComponent(PhoneNumber)}`,
        'put',
        null,
        onSuccess,
        onFailure
      ),
    changeEmailStatus: (ContactId, EmailAddress, onSuccess, onFailure) =>
      proxy.run(
        `Customers/${encodeURIComponent(
          ContactId
        )}/EmailAddress/${encodeURIComponent(EmailAddress)}`,
        'put',
        null,
        onSuccess,
        onFailure
      ),
    setPhoneAsDefault: (
      ContactId,
      PhoneNumber,
      Priority,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Customers/${encodeURIComponent(
          ContactId
        )}/PhoneNumber/${encodeURIComponent(
          PhoneNumber
        )}/Priority/${encodeURIComponent(Priority)}`,
        'put',
        null,
        onSuccess,
        onFailure
      ),
    setEmailAsDefault: (
      ContactId,
      EmailAddress,
      Priority,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Customers/${encodeURIComponent(
          ContactId
        )}/EmailAddress/${encodeURIComponent(
          EmailAddress
        )}/Priority/${encodeURIComponent(Priority)}`,
        'put',
        null,
        onSuccess,
        onFailure
      ),
    addNewPhoneNumber: (
      ContactId,
      PhoneNumber,
      PhoneType,
      Priority,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Customers/${encodeURIComponent(
          ContactId
        )}/PhoneNumber/${encodeURIComponent(PhoneNumber)}/${encodeURIComponent(
          PhoneType
        )}/${encodeURIComponent(Priority)}`,
        'post',
        null,
        onSuccess,
        onFailure
      ),
    addNewEmailAddress: (
      ContactId,
      EmailAddress,
      EmailType,
      Priority,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Customers/${encodeURIComponent(
          ContactId
        )}/EmailAddress/${encodeURIComponent(
          EmailAddress
        )}/${encodeURIComponent(EmailType)}/${encodeURIComponent(Priority)}`,
        'post',
        null,
        onSuccess,
        onFailure
      ),
    getOccupations: (onSuccess, onFailure) =>
      proxy.run('Customers/occupations', 'get', null, onSuccess, onFailure, {
        silent: true,
      }),
    getCreditsSettings: (onSuccess, onFailure) =>
      proxy.run(
        'Activities/SMS/CreditsSettings',
        'get',
        null,
        onSuccess,
        onFailure,
        {
          silent: true,
        }
      ),
    /******/

    /**SMS APIs**/
    sendMessage: (smsObj, onSuccess, onFailure) =>
      proxy.run('Activities/SMS', 'post', smsObj, onSuccess, onFailure, {
        silent: true,
      }),
    setMessageRead: (smsId, onSuccess, onFailure) =>
      proxy.run(
        `Activities/SMS/read/${encodeURIComponent(smsId)}`,
        'put',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    setMessageUnread: (smsId, onSuccess, onFailure) =>
      proxy.run(
        `Activities/SMS/unread/${encodeURIComponent(smsId)}`,
        'put',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    getUnreadMessagesCount: (EntityId, onSuccess, onFailure) =>
      proxy.run(
        `Activities/SMS/UnreadCount/${encodeURIComponent(EntityId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    getAllProducts: (BranchId, SectionName, onSuccess, onFailure, params) =>
      proxy.run(
        `Products/All/${encodeURIComponent(BranchId)}/${encodeURIComponent(SectionName)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        {
          ...params,
          silent: true,
        }
      ),
    getPracticeProducts: (onSuccess, onFailure) =>
      proxy.run(
        'Products/PracticeProductCodes',
        'get',
        null,
        onSuccess,
        onFailure,
        {
          silent: true,
        }
      ),
    /******/

    /**Performance Report**/
    getCallPerformance: (
      DateFrom,
      DateTo,
      GroupPeriod,
      FiltersObj,
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `CallPerformance/${DateFrom}/${DateTo}/${GroupPeriod}`,
        'post',
        FiltersObj,
        onSuccess,
        onFailure,
        params
      ),
    getBranchUsersByRole: (BranchId, RoleIds, onSuccess, onFailure) =>
      proxy.run(
        `Branches/${encodeURIComponent(BranchId)}/UsersByRoles`,
        'post',
        RoleIds,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    getBranchSmtpEmail: (BranchId, onSuccess, onFailure) =>
      proxy.run(
        `Branches/SMTPEmail/${BranchId}`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    /****/

    /**Appointments page apis**/
    getEventsByperiod: (
      FromDate,
      ToDate,
      BranchId,
      onSuccess,
      onFailure,
      options = {}
    ) =>
      proxy.run(
        `Activities/Appointment/${encodeURIComponent(
          FromDate
        )}/${encodeURIComponent(ToDate)}/${encodeURIComponent(BranchId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        options
      ),
    updateAppointment: (
      AppointmentId,
      UpdatedAppointment,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Activities/Appointment/${encodeURIComponent(AppointmentId)}`,
        'put',
        UpdatedAppointment,
        onSuccess,
        onFailure
      ),
    addNewAppointment: (BranchId, NewAppointment, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Appointment/${encodeURIComponent(BranchId)}`,
        'post',
        NewAppointment,
        onSuccess,
        onFailure
      ),
    endAppointment: (AppointmentId, AppointmentData, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Appointment/end/${encodeURIComponent(AppointmentId)}`,
        'put',
        {
          ...AppointmentData,
          nextActivityData: AppointmentData?.nextActivityData
            ? JSON.stringify(AppointmentData.nextActivityData)
            : null,
        },
        onSuccess,
        onFailure
      ),
    searchContactByName: (
      BranchId,
      SearchValue,
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Customers/LookupContacts/${encodeURIComponent(BranchId)}/${encodeURIComponent(SearchValue)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    searchCitiesByName: (BranchId, SearchValue, params, onSuccess, onFailure) =>
      proxy.run(
        `Customers/LookupCities/${encodeURIComponent(BranchId)}/${encodeURIComponent(SearchValue)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    /****/

    /**Notes**/
    putNotes: (NotesModel, onSuccess, onFailure) =>
      proxy.run(
        'Activities/Call/Notes',
        'put',
        NotesModel,
        onSuccess,
        onFailure
      ),
    /****/

    /**Massive sms**/
    getMassiveSMSHistory: (params, onSuccess, onFailure) =>
      proxy.run(
        'Activities/MassiveSMS/history',
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getMassiveSMSPreview: (Filters, onSuccess, onFailure) =>
      proxy.run(
        'Activities/MassiveSMS/preview',
        'post',
        Filters,
        onSuccess,
        onFailure
      ),
    getSectionTemplates: (SectionName, params, onSuccess, onFailure) =>
      proxy.run(
        `Templates/${encodeURIComponent(SectionName)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    sendMassiveSMS: (MassiveObj, onSuccess, onFailure) =>
      proxy.run(
        'Activities/MassiveSMS',
        'post',
        MassiveObj,
        onSuccess,
        onFailure
      ),
    deleteMassiveSMS: (ActivityId, params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/MassiveSMS/delete/${encodeURIComponent(ActivityId)}`,
        'delete',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getMassiveDetails: (params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/MassiveSMS/detailsHistory`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    removeMassiveToCustomers: (MassiveCustomersObject, onSuccess, onFailure) =>
      proxy.run(
        'Activities/MassiveSMS/removeSMS',
        'delete',
        MassiveCustomersObject,
        onSuccess,
        onFailure
      ),
    getAllTags: (params, onSuccess, onFailure) =>
      proxy.run('Engagement/Tag', 'get', null, onSuccess, onFailure, params),
    getMassiveActivities: (
      { campaignName, branchId, activityType } = {},
      params,
      onSuccess,
      onFailure
    ) => {
      const query = new URLSearchParams();
      if (campaignName) query.append('CampaignName', campaignName);
      branchId?.forEach((id) => query.append('BranchId', id));
      activityType?.forEach((type) => query.append('ActivityType', type));
      const queryString = query.toString();

      return proxy.run(
        `Activities/MassiveSMS/Stats${queryString ? `?${queryString}` : ''}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      );
    },
    /****/

    /**Practices**/
    getPracticesHistory: (BranchId, params, onSuccess, onFailure) =>
      proxy.run(
        `Products/Practice/GetHistory/${BranchId}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    export2ExcelPracticesHistory: (BranchId, params, onSuccess, onFailure) =>
      proxy.run(
        `Products/Practice/GetHistory/Export2Excel/${BranchId}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    createPractice: (BranchId, PracticeData, onSuccess, onFailure) =>
      proxy.run(
        `Products/Practice/Create/${BranchId}`,
        'post',
        PracticeData,
        onSuccess,
        onFailure
      ),
    importPractices: (BranchId, FormData, onSuccess, onFailure) =>
      proxy.run(
        `Products/Practice/Import/${encodeURIComponent(BranchId)}`,
        'post',
        FormData,
        onSuccess,
        onFailure,
        { doNotStringify: true }
      ),
    editPractice: (PracticeData, onSuccess, onFailure) =>
      proxy.run(
        'Products/Practice/Update',
        'put',
        PracticeData,
        onSuccess,
        onFailure
      ),
    deletePractice: (PracticeId, onSuccess, onFailure) =>
      proxy.run(
        `Products/Practice/${PracticeId}`,
        'delete',
        null,
        onSuccess,
        onFailure
      ),
    searchCompanies: (CompanySearch, onSuccess, onFailure) =>
      proxy.run(
        `Products/Practice/Companies/${CompanySearch}`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    /****/

    /**Max branches distance KM**/
    getBranchMaxDistance: (BranchId, onSuccess, onFailure) =>
      proxy.run(
        `Branches/MaxDistance/${encodeURIComponent(BranchId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),

    /**User management**/
    getBranchUsers: (BranchId, onSuccess, onFailure) =>
      proxy.run(`Users/GetAll/${BranchId}`, 'get', null, onSuccess, onFailure),
    getRoles: (onSuccess, onFailure) =>
      proxy.run('Users/GetRoles', 'get', null, onSuccess, onFailure, {
        silent: true,
      }),
    registerUser: (UserModel, onSuccess, onFailure) =>
      proxy.run('Auth/register', 'post', UserModel, onSuccess, onFailure),
    updateUser: (UserId, UserModel, onSuccess, onFailure) =>
      proxy.run(
        `Auth/updateUser/${UserId}`,
        'post',
        UserModel,
        onSuccess,
        onFailure
      ),
    disableUser: (UserId, onSuccess, onFailure) =>
      proxy.run(
        `Auth/deleteUserLogically/${encodeURIComponent(UserId)}`,
        'put',
        null,
        onSuccess,
        onFailure
      ),
    getUserBranches: (UserId, onSuccess, onFailure) =>
      proxy.run(
        `Users/GetUserBranches/${encodeURIComponent(UserId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    addUserToBranch: (UserId, BranchesList, InEdit, onSuccess, onFailure) =>
      proxy.run(
        `Users/AddToBranch/${encodeURIComponent(UserId)}/${InEdit}`,
        'put',
        BranchesList,
        onSuccess,
        onFailure
      ),
    /****/

    /** WELCOME CALLS **/
    getDealerOptions: (SearchValue, onSuccess, onFailure) =>
      proxy.run(
        `Customers/DynamicFeatures/Source Welcome/Dealer/${encodeURIComponent(SearchValue)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    getOfferOptions: (Section, SearchValue, onSuccess, onFailure) =>
      proxy.run(
        `Customers/DynamicFeatures/Source ${encodeURIComponent(Section)}/Tag/${encodeURIComponent(SearchValue)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    /****/

    /***TEMPLATES***/
    getAllTemplates: (params, onSuccess, onFailure) =>
      proxy.run(`Templates`, 'get', null, onSuccess, onFailure, params),
    getStructuresTemplates: (Scope, onSuccess, onFailure) =>
      proxy.run(
        `Templates/Structures/${encodeURIComponent(Scope)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        {}
      ),
    getDynamicEntities: (params, onSuccess, onFailure) =>
      proxy.run(
        'Templates/Entities',
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    createTemplate: (TemplateObj, params, onSuccess, onFailure) =>
      proxy.run('Templates', 'post', TemplateObj, onSuccess, onFailure, params),
    editTemplate: (TemplateObj, params, onSuccess, onFailure) =>
      proxy.run('Templates', 'put', TemplateObj, onSuccess, onFailure, params),
    deleteTemplate: (TemplateId, params, onSuccess, onFailure) =>
      proxy.run(
        `Templates/${encodeURIComponent(TemplateId)}`,
        'delete',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getSectionOutcomes: (SectionName, params, onSuccess, onFailure) =>
      proxy.run(
        `Templates/CallOutcomes${SectionName ? `/${encodeURIComponent(SectionName)}` : ''}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    linkOutcomesToTemplate: (
      TemplateId,
      OutcomesAr,
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Templates/${encodeURIComponent(TemplateId)}`,
        'post',
        OutcomesAr,
        onSuccess,
        onFailure,
        params
      ),
    /*****/

    /***LANDING PAGES***/
    getLandingPage: (LandingId, ActivityId, params, onSuccess, onFailure) =>
      proxy.run(
        `Engagement/LandingPage/${encodeURIComponent(LandingId)}/${encodeURIComponent(ActivityId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getAllLandingPages: (onSuccess, onFailure) =>
      proxy.run('Engagement/LandingPage', 'get', null, onSuccess, onFailure),
    createLandingPage: (LandingPageObj, params, onSuccess, onFailure) =>
      proxy.run(
        'Engagement/LandingPage',
        'post',
        LandingPageObj,
        onSuccess,
        onFailure,
        params
      ),
    deleteLandingPage: (LandingPageId, params, onSuccess, onFailure) =>
      proxy.run(
        `Engagement/LandingPage/${encodeURIComponent(LandingPageId)}`,
        'delete',
        null,
        onSuccess,
        onFailure,
        params
      ),
    editLandingPage: (LandingPageObj, params, onSuccess, onFailure) =>
      proxy.run(
        'Engagement/LandingPage',
        'put',
        LandingPageObj,
        onSuccess,
        onFailure,
        params
      ),
    /*****/

    /***CTA***/
    createCallToAction: (CtaObj, params, onSuccess, onFailure) =>
      proxy.run('Engagement/CTA', 'post', CtaObj, onSuccess, onFailure, params),
    getCallToActions: (params, onSuccess, onFailure) =>
      proxy.run('Engagement/CTA', 'get', null, onSuccess, onFailure, params),
    registerCallToActionInteraction: (
      CtaId,
      ActivityId,
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `Engagement/CTA/${encodeURIComponent(CtaId)}/${encodeURIComponent(ActivityId)}`,
        'post',
        {},
        onSuccess,
        onFailure,
        params
      ),
    /*****/

    /***MEDIA***/
    uploadMedia: (MediaObj, params, onSuccess, onFailure) =>
      proxy.run(
        'Engagement/media',
        'post',
        MediaObj,
        onSuccess,
        onFailure,
        params
      ),
    getMedia: (onSuccess, onFailure) =>
      proxy.run('Engagement/media', 'get', null, onSuccess, onFailure),
    getSingleMedia: (MediaId, BranchId, params, onSuccess, onFailure) =>
      proxy.run(
        `Engagement/media/${encodeURIComponent(MediaId)}/${encodeURIComponent(BranchId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    deleteMedia: (MediaId, IsCollection, params, onSuccess, onFailure) =>
      proxy.run(
        `Engagement/media/${encodeURIComponent(MediaId)}/${encodeURIComponent(IsCollection)}`,
        'delete',
        null,
        onSuccess,
        onFailure,
        params
      ),
    /*****/

    /***WAVE CONFIGURATION***/
    importWave: (FormData, params, onSuccess, onFailure) =>
      proxy.run(
        'Customers/WaveSections/ImportCustomers',
        'post',
        FormData,
        onSuccess,
        onFailure,
        params
      ),

    getImportHistory: (params, onSuccess, onFailure) =>
      proxy.run(
        'Customers/WaveSections/RequestsHistory',
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getCurrentWaveConfigs: (onSuccess, onFailure) =>
      proxy.run('WaveConfig', 'get', null, onSuccess, onFailure, {}),
    saveWaveConfigs: (Configurations, onSuccess, onFailure) =>
      proxy.run('WaveConfig', 'post', Configurations, onSuccess, onFailure, {}),
    reloadFilters: (onSuccess, onFailure) =>
      proxy.run('WaveConfig/ReloadFilters', 'get', null, onSuccess, onFailure),
    downloadWaveFile: (RequestId, params, onSuccess, onFailure) =>
      proxy.run(
        `Customers/WaveSections/DownloadWave/${RequestId}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    /**Call stats**/
    getStats: (
      BranchId,
      statsPeriod,
      SectionName,
      WavePeriod,
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `CallStats/${encodeURIComponent(statsPeriod)}/${encodeURIComponent(BranchId)}/${encodeURIComponent(
          SectionName
        )}/${encodeURIComponent(WavePeriod)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    /*****/

    export2ExcelSMSPurchases: (params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/SMSPurchases/Export2Excel`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    createSMSPurchase: (PurchaseData, onSuccess, onFailure) =>
      proxy.run(
        `Activities/SMSPurchase`,
        'post',
        PurchaseData,
        onSuccess,
        onFailure
      ),
    editSMSPurchase: (PurchaseData, onSuccess, onFailure) =>
      proxy.run(
        `Activities/SMSPurchase`,
        'put',
        PurchaseData,
        onSuccess,
        onFailure
      ),
    deleteSMSPurchase: (Id, onSuccess, onFailure) =>
      proxy.run(
        `Activities/SMSPurchase/${encodeURIComponent(Id)}`,
        'delete',
        null,
        onSuccess,
        onFailure
      ),
    updateSMSPurchaseStateToWaiting: (purchaseId, onSuccess, onFailure) =>
      proxy.run(
        `Activities/SMSPurchase/SetWaiting/${encodeURIComponent(purchaseId)}`,
        'put',
        purchaseId,
        onSuccess,
        onFailure
      ),

    updateSMSPurchaseStateToProcessing: (purchaseId, onSuccess, onFailure) =>
      proxy.run(
        `Activities/SMSPurchase/SetProcessing/${encodeURIComponent(purchaseId)}`,
        'put',
        purchaseId,
        onSuccess,
        onFailure
      ),

    getUnitPrice: (onSuccess, onFailure) =>
      proxy.run(`Activities/SMS/UnitPrice`, 'get', null, onSuccess, onFailure),

    getSettings: (onSuccess, onFailure) =>
      proxy.run(`Activities/Settings`, 'get', null, onSuccess, onFailure),

    getSettingValue: (SettingName, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Settings/${encodeURIComponent(SettingName)}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),

    createSetting: (Settings, onSuccess, onFailure) =>
      proxy.run(`Activities/Setting`, 'post', Settings, onSuccess, onFailure),

    editSetting: (Settings, onSuccess, onFailure) =>
      proxy.run(`Activities/Setting`, 'put', Settings, onSuccess, onFailure),

    getUserImaps: (onSuccess, onFailure) =>
      proxy.run(`Activities/UserImaps`, 'get', null, onSuccess, onFailure),

    createUserImap: (Settings, onSuccess, onFailure) =>
      proxy.run(`Activities/UserImaps`, 'post', Settings, onSuccess, onFailure),

    editUserImap: (Settings, onSuccess, onFailure) =>
      proxy.run(`Activities/UserImaps`, 'put', Settings, onSuccess, onFailure),

    setLicence: (Roles, onSuccess, onFailure) =>
      proxy.run('Users/SetLicence', 'put', Roles, onSuccess, onFailure),

    getBranches: (onSuccess, onFailure) =>
      proxy.run(
        `Branches/BranchesAndBranchSim`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    createBranch: (Branches, onSuccess, onFailure) =>
      proxy.run(
        'Branches/BranchesAndBranchSim',
        'post',
        Branches,
        onSuccess,
        onFailure
      ),
    updateBranch: (Branches, onSuccess, onFailure) =>
      proxy.run(
        'Branches/BranchesAndBranchSim',
        'put',
        Branches,
        onSuccess,
        onFailure
      ),
    getBranchSources: (onSuccess, onFailure) =>
      proxy.run(`Branches/BranchSources`, 'get', null, onSuccess, onFailure),
    updateBranchSource: (BranchSources, onSuccess, onFailure) =>
      proxy.run(
        'Branches/BranchSources',
        'put',
        BranchSources,
        onSuccess,
        onFailure
      ),
    getLeads: (BranchId, params, onSuccess, onFailure) =>
      proxy.run(
        `Leads/All/${encodeURIComponent(BranchId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getSubsections: (SectionName, params, onSuccess, onFailure) =>
      proxy.run(
        `Customers/WaveSections/${SectionName}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getLead: (leadId, BranchId, onSuccess, onFailure) =>
      proxy.run(
        `Leads/${encodeURIComponent(leadId)}/${encodeURIComponent(BranchId)}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    addLeads: (Leads, onSuccess, onFailure) =>
      proxy.run(`Leads`, 'post', Leads, onSuccess, onFailure),
    updateLeads: (Leads, onSuccess, onFailure) =>
      proxy.run(`Leads`, 'put', Leads, onSuccess, onFailure),
    getLeadOrigins: (params, onSuccess, onFailure) =>
      proxy.run(`Leads/LeadOrigins`, 'get', null, onSuccess, onFailure, params),
    createLeadOrigin: (LeadOrigins, onSuccess, onFailure) =>
      proxy.run('Leads/LeadOrigins', 'post', LeadOrigins, onSuccess, onFailure),
    editLeadOrigin: (LeadOrigins, onSuccess, onFailure) =>
      proxy.run('Leads/LeadOrigins', 'put', LeadOrigins, onSuccess, onFailure),
    deleteLeadOrigin: (Id, onSuccess, onFailure) =>
      proxy.run(
        `Leads/LeadOrigins/${encodeURIComponent(Id)}`,
        'delete',
        Id,
        onSuccess,
        onFailure
      ),
    getContactTypes: (params, onSuccess, onFailure) =>
      proxy.run(
        `Customers/ContactTypes`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getAddressTypes: (params, onSuccess, onFailure) =>
      proxy.run(
        `Customers/AddressTypes`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getEmailTypes: (onSuccess, onFailure) =>
      proxy.run(`Customers/EmailTypes`, 'get', null, onSuccess, onFailure),
    getPhoneTypes: (onSuccess, onFailure) =>
      proxy.run(`Customers/PhoneTypes`, 'get', null, onSuccess, onFailure),
    leadToCustomer: (leadId, onSuccess, onFailure) =>
      proxy.run(
        `Leads/LeadToCustomer/${encodeURIComponent(leadId)}`,
        'post',
        null,
        onSuccess,
        onFailure
      ),
    addCustomer: (Customer, onSuccess, onFailure) =>
      proxy.run(`Customers`, 'post', Customer, onSuccess, onFailure),
    updateCustomer: (Customer, onSuccess, onFailure) =>
      proxy.run(`Customers`, 'put', Customer, onSuccess, onFailure),
    addContact: (Contact, onSuccess, onFailure) =>
      proxy.run(`Customers/Contact`, 'post', Contact, onSuccess, onFailure),
    updateContact: (Contact, onSuccess, onFailure) =>
      proxy.run(`Customers/Contact`, 'put', Contact, onSuccess, onFailure),
    getPivotData: (
      DateFrom,
      DateTo,
      Grouping,
      CallPerformanceModel,
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `CallPerformance/PivotData/${DateFrom}/${DateTo}/${Grouping}`,
        'post',
        CallPerformanceModel,
        onSuccess,
        onFailure,
        params
      ),
    getPivotDataWavePeriod: (
      WavePeriod,
      Payload,
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `CallPerformance/PivotData/${encodeURIComponent(WavePeriod)}`,
        'post',
        Payload,
        onSuccess,
        onFailure,
        params
      ),
    getDynamicFeaturesById: (Id, params, onSuccess, onFailure) =>
      proxy.run(
        `Customers/DynamicFeatures/${encodeURIComponent(Id)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getDynamicFeaturesOptionsById: (Id, params, onSuccess, onFailure) =>
      proxy.run(
        `Customers/DynamicFeaturesOptions/${encodeURIComponent(Id)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getUsersByRoles: (rolesArray, onSuccess, onFailure) =>
      proxy.run(`Users/GetByRoles`, 'post', rolesArray, onSuccess, onFailure, {
        silent: true,
      }),

    /**Commercial customers campaigns **/
    getCommercialCampaignsHistory: (params, onSuccess, onFailure) =>
      proxy.run(
        'CommercialCampaigns/History',
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    createCommercialCampaign: (CommercialCampaign, onSuccess, onFailure) =>
      proxy.run(
        'CommercialCampaigns/Create',
        'post',
        CommercialCampaign,
        onSuccess,
        onFailure
      ),
    deleteCommercialCampaign: (CampaignId, onSuccess, onFailure) =>
      proxy.run(
        `CommercialCampaigns/Delete/${encodeURIComponent(CampaignId)}`,
        'delete',
        null,
        onSuccess,
        onFailure
      ),
    updateCommercialCampaign: (CommercialCampaign, onSuccess, onFailure) =>
      proxy.run(
        'CommercialCampaigns/Update',
        'put',
        CommercialCampaign,
        onSuccess,
        onFailure
      ),
    getActivitiesOutcomes: (onSuccess, onFailure) =>
      proxy.run(`Activities/Outcomes`, 'get', null, onSuccess, onFailure),
    addActivityOutcomes: (ActivityOutcome, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Outcomes/Add`,
        'post',
        ActivityOutcome,
        onSuccess,
        onFailure
      ),
    updateActivityOutcomes: (ActivityOutcome, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Outcomes/Update`,
        'put',
        ActivityOutcome,
        onSuccess,
        onFailure
      ),
    getActivityTypes: (onSuccess, onFailure) =>
      proxy.run(`Activities/Types`, 'get', null, onSuccess, onFailure),
    activityOutcomesToggle: (ActivityOutcomeId, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Outcomes/ToggleActive/${encodeURIComponent(ActivityOutcomeId)}`,
        'put',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),

    activity: (BaseActivity, ExtensionData, params, onSuccess, onFailure) =>
      proxy.run(
        `Activities`,
        'post',
        { ...BaseActivity, extensionData: JSON.stringify(ExtensionData) },
        onSuccess,
        onFailure,
        params
      ),
    closeActivity: (ActivityData, onSuccess, onFailure) =>
      proxy.run(`Activities`, 'put', ActivityData, onSuccess, onFailure),
    getCampaignDividers: (onSuccess, onFailure) =>
      proxy.run(
        `CommercialCampaigns/Divider`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    addCampaignDivider: (CampaignDivider, onSuccess, onFailure) =>
      proxy.run(
        `CommercialCampaigns/Divider`,
        'post',
        CampaignDivider,
        onSuccess,
        onFailure
      ),
    updateCampaignDivider: (CampaignDivider, onSuccess, onFailure) =>
      proxy.run(
        `CommercialCampaigns/Divider`,
        'put',
        CampaignDivider,
        onSuccess,
        onFailure
      ),
    deleteCampaignDivider: (DividerId, onSuccess, onFailure) =>
      proxy.run(
        `CommercialCampaigns/Divider/${encodeURIComponent(DividerId)}`,
        'delete',
        null,
        onSuccess,
        onFailure
      ),
    getDividedCustomers: (CampaignId, params, onSuccess, onFailure) =>
      proxy.run(
        `CommercialCampaigns/Divider/${encodeURIComponent(CampaignId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getPaginatedDividerCustomers: (
      DividerId,
      CampaignId,
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `CommercialCampaigns/Divider/${encodeURIComponent(DividerId)}/${encodeURIComponent(CampaignId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getCampaignFunnel: (CampaignId, Filters, onSuccess, onFailure) =>
      proxy.run(
        `CommercialCampaigns/Funnel/${encodeURIComponent(CampaignId)}`,
        'post',
        Filters,
        onSuccess,
        onFailure
      ),
    lookupCustomerByFiscalCode: (BranchId, FiscalCode, onSuccess, onFailure) =>
      proxy.run(
        `Customers/LookupCustomerByFiscalCode/${encodeURIComponent(BranchId)}/${encodeURIComponent(FiscalCode)}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    getAppointmentPivotData: (
      DateFrom,
      DateTo,
      PerformanceModel,
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `ActivityPerformance/Appointments/${encodeURIComponent(DateFrom)}/${encodeURIComponent(DateTo)}`,
        'post',
        PerformanceModel,
        onSuccess,
        onFailure,
        params
      ),
    getPivotConfigurations: (PivotType, onSuccess, onFailure) =>
      proxy.run(
        `CallPerformance/PivotConfiguration/${encodeURIComponent(PivotType)}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    getCallTargets: (BranchId, onSuccess, onFailure) =>
      proxy.run(
        `CallPerformance/CallTargetProgresses/${encodeURIComponent(BranchId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    createPivotConfiguration: (ConfigModel, onSuccess, onFailure) =>
      proxy.run(
        `CallPerformance/PivotConfiguration`,
        'post',
        ConfigModel,
        onSuccess,
        onFailure
      ),
    editPivotConfiguration: (ConfigModel, onSuccess, onFailure) =>
      proxy.run(
        `CallPerformance/PivotConfiguration`,
        'put',
        ConfigModel,
        onSuccess,
        onFailure
      ),
    deletePivotConfiguration: (ConfigId, onSuccess, onFailure) =>
      proxy.run(
        `CallPerformance/PivotConfiguration/${encodeURIComponent(ConfigId)}`,
        'delete',
        null,
        onSuccess,
        onFailure
      ),
    getActivityPriority: (BranchId, params, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Priority/${encodeURIComponent(BranchId)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getRedemption: (
      DateFrom,
      DateTo,
      EntityType,
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `CallPerformance/Redemption/${encodeURIComponent(DateFrom)}/${encodeURIComponent(DateTo)}/${encodeURIComponent(EntityType)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    getUserRollingRedemption: (onSuccess, onFailure) =>
      proxy.run(
        `CallPerformance/Redemption`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    getRollingRedemption: (
      DateFrom,
      EntityType,
      params,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `CallPerformance/RollingRedemption/${encodeURIComponent(DateFrom)}/${encodeURIComponent(EntityType)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        params
      ),
    updateUserExtensionData: (keyName, value, onSuccess, onFailure) =>
      proxy.run(
        `Users/UpdateExtensionData/${encodeURIComponent(keyName)}/${encodeURIComponent(value)}`,
        'put',
        null,
        onSuccess,
        onFailure
      ),
    exportRedemption2Excel: (DateFrom, DateTo, onSuccess, onFailure) =>
      proxy.run(
        `CallPerformance/Redemption2Excel/${encodeURIComponent(DateFrom)}/${encodeURIComponent(DateTo)}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    exportRollingRedemption2Excel: (DateFrom, onSuccess, onFailure) =>
      proxy.run(
        `CallPerformance/RollingRedemption2Excel/${encodeURIComponent(DateFrom)}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    makeCallWithoutContact: (PhoneNumber, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Call/Make3CXCall/${encodeURIComponent(PhoneNumber)}`,
        'post',
        null,
        onSuccess,
        onFailure
      ),
    dropCallWithoutContact: (ParticipantId, onSuccess, onFailure) =>
      proxy.run(
        `Activities/Call/Drop3CXCall/${encodeURIComponent(ParticipantId)}`,
        'post',
        null,
        onSuccess,
        onFailure
      ),
    getWaveFilters: (onSuccess, onFailure) =>
      proxy.run(`WaveConfig/Filters`, 'get', null, onSuccess, onFailure),
    getTranslations: (onSuccess, onFailure) =>
      proxy.run(`Translation`, 'get', null, onSuccess, onFailure),
    createWaveFilter: (WaveFilter, onSuccess, onFailure) =>
      proxy.run(`WaveConfig/Filters`, 'post', WaveFilter, onSuccess, onFailure),
    updateWaveFilter: (WaveFilter, onSuccess, onFailure) =>
      proxy.run(`WaveConfig/Filters`, 'put', WaveFilter, onSuccess, onFailure),
    toggleWaveFilter: (FilterId, onSuccess, onFailure) =>
      proxy.run(
        `WaveConfig/Filters/${encodeURIComponent(FilterId)}`,
        'delete',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    lookupZipCode: (zipCode, onSuccess, onFailure) =>
      proxy.run(
        `Products/lookUpZipCode/${encodeURIComponent(zipCode)}`,
        'get',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    getStagedBranches: (onSuccess, onFailure) =>
      proxy.run('WaveImport/StagedBranches', 'get', null, onSuccess, onFailure),
    getWaveFilterBranches: (BranchId, onSuccess, onFailure) =>
      proxy.run(
        `WaveImport/WaveFilterBranches/${BranchId}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    lookupDynamicOptions: (OptionsUrl, onSuccess, onFailure) =>
      proxy.run(
        `DataSourceRegistry/${encodeURIComponent(OptionsUrl)}?Parameters={}`,
        'post',
        {},
        onSuccess,
        onFailure,
        { silent: true }
      ),
    lookupKeys: (searchValue, onSuccess, onFailure) =>
      proxy.run(
        `DataSourceRegistry/${encodeURIComponent(searchValue)}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    runWaveSimulation: (BranchId, FiltersPayload, onSuccess, onFailure) =>
      proxy.run(
        `WaveImport/RunWaveSimulation/${BranchId}`,
        'post',
        FiltersPayload,
        onSuccess,
        onFailure
      ),
    getUncommittedWaveSimulations: (BranchId, onSuccess, onFailure) =>
      proxy.run(
        `WaveImport/UncommittedWaveSimulation/${BranchId}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    getWaveSimulation: (SimulationId, onSuccess, onFailure) =>
      proxy.run(
        `WaveImport/WaveSimulation/${SimulationId}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
    reRunWaveSimulation: (SimulationId, FiltersPayload, onSuccess, onFailure) =>
      proxy.run(
        `WaveImport/ReRunWaveSimulation/${encodeURIComponent(SimulationId)}`,
        'put',
        FiltersPayload,
        onSuccess,
        onFailure
      ),
    commitWaveSimulation: (SimulationId, onSuccess, onFailure) =>
      proxy.run(
        `WaveImport/CommitSimulation/${encodeURIComponent(SimulationId)}`,
        'put',
        null,
        onSuccess,
        onFailure
      ),
    resolveSimulationOverlaps: (
      SimulationId,
      OverlapsResolutions,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `WaveImport/ResolveOverlaps/${encodeURIComponent(SimulationId)}`,
        'post',
        OverlapsResolutions,
        onSuccess,
        onFailure
      ),
    toggleWaveFilterBranch: (
      BranchId,
      SectionId,
      WaveFilterId,
      onSuccess,
      onFailure
    ) =>
      proxy.run(
        `WaveImport/WaveFilterBranches/${encodeURIComponent(BranchId)}/${encodeURIComponent(SectionId)}/${encodeURIComponent(WaveFilterId)}`,
        'put',
        null,
        onSuccess,
        onFailure,
        { silent: true }
      ),
    getWaveReport: (WavePeriod, BranchId, onSuccess, onFailure) =>
      proxy.run(
        `WavePerformance/${encodeURIComponent(WavePeriod)}${BranchId ? `?BranchId=${encodeURIComponent(BranchId)}` : ''}`,
        'get',
        null,
        onSuccess,
        onFailure
      ),
  };
}
